import React from 'react';
import { AdminRoutePath } from 'src/entities/adminRoute';
import { useProcessingNegotiationBadgeCount } from 'src/entities/processing';
import { generateAdminPath } from 'src/app/shared/utils/generateAdminPath';
import { SidebarSectionItem } from '../../sectionItem';

export const ProcessingAndReviewsSidebarItem: React.FC = () => {
  const count = useProcessingNegotiationBadgeCount();

  return (
    <SidebarSectionItem
      badgeValue={count > 0 ? count : undefined}
      href={generateAdminPath(AdminRoutePath.ProcessingAndReviews)}
      title="Заказы и отзывы"
    />
  );
};
